class Video {
  constructor(settings) {
    const videoComponents = document.querySelectorAll(settings.videoComponentSelector);

    videoComponents.forEach(videoComponent => {
      const button = videoComponent.querySelector(settings.videoButtonSelector);
      button.addEventListener('click', (e) => {
        const iframe = videoComponent.querySelector('iframe');
        const video = videoComponent.querySelector('video');

        this.stopAllVideos(videoComponents);

        // html5 video element
        if (video) {
          video.play();
        }
        // iframe autoplay youtube + vimeo
        else if (iframe.src) {
          if (iframe.src.startsWith('https://player.vimeo.com/') && Vimeo && Vimeo.Player) {
            videoComponent.player = new Vimeo.Player(iframe);
          }

          iframe.src = iframe.src + '?autoplay=1';
        }

        button.style.display = 'none';
      });
    });
  }

  stopAllVideos(videos) {
    videos.forEach(videoComponent => {
      const iframe = videoComponent.querySelector('iframe');
      const video = videoComponent.querySelector('video');

      if (video) {
        // HTML5 video palyer
        video.pause();
      } else if (iframe && iframe.src) {
        // youtube stop event
        if (iframe.src.startsWith('https://youtube.com/')) {
          iframe.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
        }
        // vimeo stop event
        else if (iframe.src.startsWith('https://player.vimeo.com/')) {
          if (videoComponent.player) {
            videoComponent.player.pause();
          }
        }
      }
    })
  }
} export default Video;
